<template>
  <div class='im'>
    <div class="container">
      <div class="kvbox">
        <img class="imkv" src="@/assets/goin/imkv.png" alt="">
      </div>
      <div class="content">
        <img class="imfont" src="@/assets/goin/font2.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Im',
  components:{ 
    
  },
  data() {
    return {
      
    }
  },
  computed:{ },
  watch:{ },
  created() {
      
  },
  mounted() {
      
  },
  methods: {
      
  }
}
</script>
<style lang='less' scoped>
.im {
  width: 100%;
  height: 913.5px;
  padding: 160px 0 105px 0;
  background: url('../../../assets/goin/imBg.png');
  .container {
    width: 1737px;
    height: 913.5px;
    position: relative;
    margin: 0 auto;
    .kvbox {
      width: 100%;
      height: 913.5px;
      position: absolute;
      top: 0;
      left: 0;
      overflow: hidden;
      .imkv {
        width: 100%;
        vertical-align: top;
      }
    }
    .content {
      width: 620px;
      height: 1000px;
      position: absolute;
      top: 50%;
      margin-top: -500px;
      right: 232.5px;
      background: #4E8B46;
      animation: first-left 1s forwards;
      opacity: 0;
      img {
        width: 502px;
        height: 647px;
        vertical-align: middle;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -323.5px;
        margin-left: -251px;
        animation: first-left 1s forwards;
        animation-delay: 0.5s;
        opacity: 0;
      }
    }
  }
  @keyframes first-left {
  0% {
    transform: translateX(100px);
    opacity: 1;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
}
</style>